module.exports = __webpack_public_path__ + "static/media/settings.33686dcf.svg";